import {combineReducers} from '@reduxjs/toolkit';

import {datasetEntitlementsReducer} from './all-entitlements/dataset-entitlements';
import {presetsReducer} from './all-entitlements/presets';
import {rolesGrantsResourcesReducer} from './all-entitlements/roles-grants-resources';
import {entitlementGrantChangeLogReducer} from './edit-grant/change-log';
import {entitlementRoleChangeLogReducer} from './edit-role/change-log';
import {entitlementResourceChangeLogReducer} from './update-resource/change-log';

export const manageEntitlementsReducer = combineReducers({
    rolesGrantsResourcesReducer,
    presetsReducer,
    datasetEntitlementsReducer,
    entitlementRoleChangeLogReducer,
    entitlementGrantChangeLogReducer,
    entitlementResourceChangeLogReducer,
});
